import React, { useEffect, useState } from 'react';
import { View, StatusBar } from 'react-native';
import { connect } from 'react-redux';

import NcFileContent from '@components/common/NCFile';
import Loading from '@components/loading';

import { navigateBack, isWeb, isPhone, parseRouteParamAsNumber } from '@helpers';
import { notchTop, scale, width } from '@components/frame';

import ColorWrapper from '@styles/colors';

import { getNCFileById } from '@reducers/manufacture';

const NCFile = (props) => {
  const { C, route, getNCFileById } = props;
  const ncFileName = route?.params?.ncFileName;
  const ncFileId = parseRouteParamAsNumber(route?.params?.ncFileId);
  const [loading, setLoading] = useState(true);
  const [ncFileInfo, setNcFileInfo] = useState({});

  useEffect(() => {
    StatusBar.setHidden(true);
    if (ncFileId) {
      (async () => {
        const info = await getNCFileById(ncFileId);
        if (info) {
          setNcFileInfo(info);
        } else {
          navigateBack();
        }
        setLoading(false);
      })();
    }

    return () => {
      StatusBar.setHidden(false);
    };
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <View
      style={[
        {
          minWidth: '100%',
          width: '100%',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: C('Background / Light / Field'),
        },
        isPhone && notchTop && { marginTop: scale(notchTop) },
      ]}
    >
      <View style={{ width: width, flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <NcFileContent
          {...{
            selectedItem: { machineStatus: ncFileInfo },
            C,
            isPreview: false,
            paddingHorizontal: isWeb ? 18 : 15,
            collapsed: true,
            showCollapse: true,
            collapseButtons: false,
            showBack: true,
            paddingTop: scale(isPhone ? 65 : 87),
            ncFileName,
            ncFileId: ncFileInfo?.ncFileId,
            oldScreen: true,
          }}
        />
      </View>
    </View>
  );
};

export default connect(null, { getNCFileById })(ColorWrapper(NCFile));
